import { updateStates } from '@/utils/reducer';
import { GET_BRAND, GET_BRANDS, GET_BRANDS_SUCCESS } from '@/store/types/brand';

const initState = {
  isLoading: true,
  list: [],
};

const reducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_BRAND:
    case GET_BRANDS:
      return updateStates(state, { isLoading: true });
    case GET_BRANDS_SUCCESS:
      return updateStates(state, { list: payload });

    default:
      return state;
  }
};

export default reducer;
